'use client';

import { useEffect, useRef, type ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { FAQSection } from 'components/shared/FAQSection';
import CustomLink from 'components/shared/CustomLink';

import { useReveal } from './useReveal';
import styles from './ScienceFaqs.module.css';

export default function ScienceFaqs() {
  const t = useTranslations('science');
  /* the heading, then the question rows, fade up as they enter. FAQSection is
     shared, so its nodes are tagged from here (this effect runs before the
     reveal's, which then picks them up) */
  const wrapRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    wrapRef.current
      ?.querySelectorAll<HTMLElement>('h2, .faq-element')
      .forEach((el) => el.setAttribute('data-reveal', ''));
  }, []);
  useReveal(wrapRef);
  const studies = (chunks: ReactNode) => (
    <CustomLink href="/science/studies/">{chunks}</CustomLink>
  );
  const app = (chunks: ReactNode) => (
    <CustomLink href="/pulsomics/">{chunks}</CustomLink>
  );

  return (
    <div ref={wrapRef}>
      <FAQSection
      bgColor="white"
      className={styles.section}
      heading={t('science.landing.faq.heading')}
      aria-label={t('science.landing.a11y.faqGroup')}
      faqData={[
        {
          title: t('science.landing.faq.accuracy.question'),
          description: t.rich('science.landing.faq.accuracy.answer', { studies }),
        },
        {
          title: t('science.landing.faq.tested.question'),
          description: t.rich('science.landing.faq.tested.answer', { studies }),
        },
        {
          title: t('science.landing.faq.published.question'),
          description: t.rich('science.landing.faq.published.answer', { studies }),
        },
        {
          title: t('science.landing.faq.data.question'),
          description: t('science.landing.faq.data.answer'),
        },
        {
          title: t('science.landing.faq.join.question'),
          description: t.rich('science.landing.faq.join.answer', { app }),
        },
        {
          title: t('science.landing.faq.lab.question'),
          description: t('science.landing.faq.lab.answer'),
        },
      ]}
      />
    </div>
  );
}
